import * as constants from '../constants/actions';


/******************************
*******  Synchronous  *********
******************************/

export function commonAlert(text, prompt = null) {
  return {
    type: constants.COMMON_ALERT,
    text,
    prompt
  };
}

export function commonCloseAlert() {
	return {
    type: constants.COMMON_CLOSE_ALERT,
  };
}

export function commonModalResize() {
	return {
    type: constants.COMMON_MODAL_RESIZE,
  };
}

export function commonOpenContact(product) {
  return {
    type: constants.COMMON_OPEN_CONTACT,
    product
  };
}

export function commonCloseContact() {
  return {
    type: constants.COMMON_CLOSE_CONTACT,
  };
}

export function commonOpenInvite() {
  return {
    type: constants.COMMON_OPEN_INVITE,
  };
}

export function commonCloseInvite() {
  return {
    type: constants.COMMON_CLOSE_INVITE,
  };
}

export function commonContactSent() {
  return {
    type: constants.COMMON_CONTACT_SENT,
  };
}

export function commonSetLastVisited(page) {
  return {
    type: constants.COMMON_SET_LAST_VISITED,
    page
  };
}

export function commonOpenNoItemContact() {
  return {
    type: constants.COMMON_OPEN_NO_ITEM_CONTACT,
  };
}

export function commonCloseNoItemContact() {
  return {
    type: constants.COMMON_CLOSE_NO_ITEM_CONTACT,
  };
}



/******************************
*******  Asynchronous  ********
******************************/





// WEBPACK FOOTER //
// ./src/actions/common.jsx